export default __webpack_public_path__ + "static/media/Snd1.65ce08cd.mp3";